import * as React from "react";
import { AbstractReactFactory } from "@projectstorm/react-canvas-core";
import { DiagramEngine } from "@projectstorm/react-diagrams-core";
import { TreeBlockType } from "../TreeBlockType";
import { DefaultTreeBlockModel } from "./DefaultTreeBlockModel";
import { TreeBlockWidget } from "./TreeBlockWidget/TreeBlockWidget";

export class RootBlockFactory extends AbstractReactFactory<
  DefaultTreeBlockModel,
  DiagramEngine
> {
  constructor() {
    super("root-block");
  }

  generateModel(initialConfig?: any): DefaultTreeBlockModel {
    return new DefaultTreeBlockModel({
      name: TreeBlockType.ROOT,
      id: TreeBlockType.ROOT
    });
  }

  generateReactWidget(event: any): JSX.Element {
    return (
      <TreeBlockWidget
        engine={this.engine as DiagramEngine}
        node={event.model}
      />
    );
  }
}
